import * as React from 'react';
import { useContext, useState } from 'react';
import { apiPost, logApiError } from "../api";
import Spinner, { SpinnerColorsEnum } from "../components/spinner";
import { isFunction } from "../helpers/utils";
import { ContextSession } from "./app";

type Props = Readonly<{
	setState: Function,
}>

/*
	Offered only from step 9, where the card was declined and no money moved.

	A decline leaves the sale, the mandate and the signed contract intact, so this
	needs nothing rebuilt — the server issues a fresh payable object against the
	same sale and returns the customer to the payment step.

	Deliberately absent from step 8. There the payment is unconfirmed rather than
	failed, so paying again risks a second charge.
 */
function RetryPaymentButton({setState}: Props) {
	const state = useContext(ContextSession);
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function retry() {
		setBusy(true);
		setError(null);

		apiPost('/resa/retryPayment/' + state?.hash).then((response) => {
			if (isFunction(setState)) {
				setState(response.data);
			}
		}).catch(function (error) {
			setBusy(false);
			setError('We couldn’t start another payment just now. Please try again in a moment, or contact the club.');
			logApiError(error);
		});
	}

	return (<>
		{error && <p className="text-red-400 text-sm mb-4">{error}</p>}
		<button
			className="mb-4 flex items-center justify-center w-full"
			disabled={busy}
			onClick={retry}
		>
			TRY PAYMENT AGAIN
			{busy && <Spinner color={SpinnerColorsEnum.Black} className="!w-4 !h-4"/>}
		</button>
	</>);
}

export default RetryPaymentButton;
